import React from 'react';
import ReactSVG from "react-svg";
import messages_en from "../en/messages_en";

const savingsGoalsBuilderKey = 'savingsGoals';
const currentLoansBuilderKey = 'currentLoans';
const lendingGoalsBuilderKey = 'lendingGoals';

const renderCardTitle = (builderKey, cardKey) => {
  const icon = messages_en[`${builderKey}.${cardKey}.icon`];
  const iconLabel = messages_en[`${builderKey}.${cardKey}`];
  return <div>
    <ReactSVG src={ icon } className='card-title-icon' />
    <span>{ iconLabel }</span>
  </div>
};

export default {    
  'savingsGoals.lifeEvent': renderCardTitle(savingsGoalsBuilderKey, 'lifeEvent'),
  'savingsGoals.education': renderCardTitle(savingsGoalsBuilderKey, 'education'),
  'savingsGoals.retirement': renderCardTitle(savingsGoalsBuilderKey, 'retirement'),
  'savingsGoals.healthCare': renderCardTitle(savingsGoalsBuilderKey, 'healthCare'),
  'savingsGoals.emergency': renderCardTitle(savingsGoalsBuilderKey, 'emergency'),
  'savingsGoals.other': renderCardTitle(savingsGoalsBuilderKey, 'other'),
  'savingsGoals.none': renderCardTitle(savingsGoalsBuilderKey, 'none'),

  'currentLoans.existingHomeLoan': renderCardTitle(currentLoansBuilderKey, 'existingHomeLoan'),
  'currentLoans.existingAutoLoan': renderCardTitle(currentLoansBuilderKey, 'existingAutoLoan'),
  'currentLoans.existingAutoLoan2': renderCardTitle(currentLoansBuilderKey, 'existingAutoLoan2'),
  'currentLoans.existingCreditCard': renderCardTitle(currentLoansBuilderKey, 'existingCreditCard'),
  'currentLoans.existingPersonalLoan': renderCardTitle(currentLoansBuilderKey, 'existingPersonalLoan'),
  'currentLoans.existingHomeEquityLoan': renderCardTitle(currentLoansBuilderKey, 'existingHomeEquityLoan'),
  'currentLoans.existingStudentLoan': renderCardTitle(currentLoansBuilderKey, 'existingStudentLoan'),
  'currentLoans.none': renderCardTitle(currentLoansBuilderKey, 'none'),

  'lendingGoals.homeOwnership': renderCardTitle(lendingGoalsBuilderKey, 'homeOwnership'),
  'lendingGoals.refinance': renderCardTitle(lendingGoalsBuilderKey, 'refinance'),
  'lendingGoals.homeImprovement': renderCardTitle(lendingGoalsBuilderKey, 'homeImprovement'),
  'lendingGoals.vehicleLoan': renderCardTitle(lendingGoalsBuilderKey, 'vehicleLoan'),
  'lendingGoals.otherLoan': renderCardTitle(lendingGoalsBuilderKey, 'otherLoan'),
  'lendingGoals.educationLoan': renderCardTitle(lendingGoalsBuilderKey, 'educationLoan'),
  'lendingGoals.debtConsolidation': renderCardTitle(lendingGoalsBuilderKey, 'debtConsolidation'),
  'lendingGoals.lineOfCredit': renderCardTitle(lendingGoalsBuilderKey, 'lineOfCredit'),
  'lendingGoals.buildOrEstablishCredit': renderCardTitle(lendingGoalsBuilderKey, 'buildOrEstablishCredit'),
};
